<template>
    <div class="bar-mobile">
        <div class="bar-container-mobile">
            <progress-bar bar-color="#AF00B1" :val="percentage" :text="percentage+'%'" :style="cssVars"></progress-bar>
        </div>
        
    </div>
</template>

<script>
import ProgressBar from 'vue-simple-progress'
    export default {
        components: {
            ProgressBar
        },
        props: {
            percentage: {
                type: Number,
                required: true
            }
        },
        computed: {
            cssVars () {
                return{
                /* variables you want to pass to css */
                '--left': this.percentage-2+'%',
                }
            }
        }
    }
</script>

<style>
.bar-mobile{
    margin-top: 12px;
}
.bar-container-mobile{
    position: relative;
}
.bar-container-mobile .vue-simple-progress-text{
  position: absolute;
  top: -30px; 
  font-family: 'Poppins', sans-serif;
  font-weight: bold;
  color: #AF00B1 !important;
  left: var(--left) !important;
}
</style>